import type { FC } from "react";

import type { UseFormReturn } from "react-hook-form";

import type { InvestmentObjective } from "~/v2/api/rest/account";
import {
  INVESTMENT_OBJECTIVE_LABEL,
  INVESTMENT_OBJECTIVE_OPTIONS,
} from "~/v2/constants/investmentObjective";
import { RadiosInput } from "../../RadiosInput";
import type { InvestmentExperience } from "./schema";

type AccountGoalsInputProps = {
  form: UseFormReturn<InvestmentExperience>;
};

export const AccountGoalsInput: FC<AccountGoalsInputProps> = ({ form }) => {
  const {
    formState: { errors },
    setValue,
    watch,
  } = form;

  const accountGoal = watch("investment_objective");
  const errorMessage = errors.investment_objective?.message;

  const onClick = (value: string) =>
    setValue("investment_objective", value as InvestmentObjective);

  return (
    <RadiosInput
      id="investment_objective"
      label={INVESTMENT_OBJECTIVE_LABEL}
      value={accountGoal}
      options={INVESTMENT_OBJECTIVE_OPTIONS}
      onSelect={onClick}
      errorMessage={errorMessage}
    />
  );
};
